'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _veIcons = require('@ali/ve-icons');

var _veIcons2 = _interopRequireDefault(_veIcons);

var _util = require('./util');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

function Action(props) {
  var action = props.action,
      handle = props.handle; // eslint-disable-line

  var className = (0, _classnames2.default)('ve-popup-action', 've-popup-action-' + (action.theme ? action.theme : 'default'));
  return _react2.default.createElement(
    'div',
    {
      className: className,
      onClick: function onClick() {
        if (typeof action.func === 'function') {
          action.func.call(handle, action);
        }
      }
    },
    action.title
  );
}

function isPointInRect(event, rect) {
  return event.clientY >= rect.top && event.clientY <= rect.bottom && event.clientX >= rect.left && event.clientX <= rect.right;
}
var Popup = (_temp = _class = function (_Component) {
  _inherits(Popup, _Component);

  function Popup() {
    _classCallCheck(this, Popup);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Popup.prototype.componentWillMount = function componentWillMount() {
    this.handle = this.props.handle;
  };

  Popup.prototype.componentDidMount = function componentDidMount() {
    var _this2 = this;

    var popup = this.shell;
    var popupRect = popup.getBoundingClientRect();
    var bounds = {
      left: 0,
      top: 0,
      right: document.documentElement.clientWidth,
      bottom: document.documentElement.clientHeight
    };
    var _props = this.props,
        target = _props.target,
        position = _props.position,
        cancelOnBlur = _props.cancelOnBlur,
        sizeFixed = _props.sizeFixed;

    var targetRect = void 0;
    if (target) {
      if (target.getBoundingClientRect) {
        targetRect = target.getBoundingClientRect();
      } else if ('clientLeft' in target) {
        targetRect = {
          width: 0,
          height: 0,
          left: target.clientLeft,
          top: target.clientTop,
          right: target.clientLeft,
          bottom: target.clientTop
        };
      }
    }

    if (targetRect) {
      var arrow = popup.querySelector('.ve-arrow');
      var arrowRect = arrow.getBoundingClientRect();

      var _resolvePosition = (0, _util.resolvePosition)(popupRect, targetRect, arrowRect, bounds, position),
          dir = _resolvePosition.dir,
          left = _resolvePosition.left,
          top = _resolvePosition.top,
          arrowLeft = _resolvePosition.arrowLeft,
          arrowTop = _resolvePosition.arrowTop;

      popup.classList.add('ve-align-' + dir);
      popup.style.top = top + 'px';
      popup.style.left = left + 'px';
      if (dir === 'top' || dir === 'bottom') {
        arrow.style.left = arrowLeft + 'px';
      } else {
        arrow.style.top = arrowTop + 'px';
      }
      popup.classList.add('ve-visible-normal');
      popup.style.transform = 'none';
    } else {
      var _resolveRelativePosit = (0, _util.resolveRelativePosition)(position, popupRect, bounds),
          _left = _resolveRelativePosit.left,
          _top = _resolveRelativePosit.top;

      popup.style.top = +_top.split('px')[0] - popupRect.height / 2 + 'px';
      popup.style.left = +_left.split('px')[0] - popupRect.width / 2 + 'px';
      popup.style.transform = 'initial';
      popup.classList.add('ve-visible-normal');
    }

    if (this.props.style) {
      ['top', 'bottom', 'left', 'right'].forEach(function (e) {
        if (_this2.props.style.hasOwnProperty(e)) {
          popup.style[e] = _this2.props.style[e];
        }
      });
    }

    if (sizeFixed) {
      popup.style.width = popupRect.width + 'px';
      popup.style.height = popupRect.height + 'px';
    }

    if (cancelOnBlur) {
      var down = function down(e) {
        var rect = popup.getBoundingClientRect();
        if (e.target && !popup.contains(e.target)) {
          if (_this2.props.checkInRect) {
            if (isPointInRect(e, rect)) {
              return;
            }
          }
          /**
           * 对于已经 unMount 的 DOM Node 我们不作考虑
           */
          if (e.target.isConnected === false) {
            return;
          }
          _this2.handle.close();
        }
      };
      document.addEventListener('mousedown', down);
      this.willDetach = function () {
        document.removeEventListener('mousedown', down);
      };
    }
  };

  Popup.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
    return false;
  };

  Popup.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.willDetach) {
      this.willDetach();
    }
    this.clearTimer();
  };

  Popup.prototype.clearTimer = function clearTimer() {
    if (this.timer) {
      clearTimeout(this.timer);
      this.timer = null;
    }
  };

  Popup.prototype.render = function render() {
    var _this3 = this;

    var className = (0, _classnames2.default)('ve-popup', this.props.className);
    var actions = this.props.actions;
    var actionsTheme = (0, _classnames2.default)('ve-popup-actions-' + this.props.actionsTheme);
    var contentWrapperClassName = (0, _classnames2.default)('ve-popup-content', {
      've-popup-content-no-padding': !this.props.contentPadding
    });
    return _react2.default.createElement(
      'div',
      { className: className, ref: function ref(_ref) {
          _this3.shell = _ref;
        }, style: this.props.style },
      this.props.target && _react2.default.createElement(
        'svg',
        { viewBox: '0 0 198 122', version: '1.1', xmlns: 'http://www.w3.org/2000/svg', width: '19', height: '12', className: 've-arrow' },
        _react2.default.createElement(
          'g',
          { id: 'Page-1', stroke: 'none', strokeWidth: '1', fill: 'none', fillRule: 'evenodd' },
          _react2.default.createElement(
            'g',
            { id: 'Group', transform: 'translate(1.000000, 1.000000)' },
            _react2.default.createElement('polygon', { fill: '#FFFFFF', points: '98 119 0 1 196 1' }),
            _react2.default.createElement('polyline', { strokeWidth: '2', points: '0.135078433 0.243023088 97.9777525 119.044718 195.997442 0.243023088' })
          )
        )
      ),
      this.props.showClose && _react2.default.createElement(_veIcons2.default.Button, {
        className: 've-popup-close',
        name: 'close',
        size: '12px',
        onClick: function onClick() {
          return _this3.handle.close();
        }
      }),
      this.props.title && _react2.default.createElement(
        'div',
        { className: 've-popup-title' },
        this.props.title
      ),
      _react2.default.createElement(
        'div',
        { className: contentWrapperClassName },
        this.props.children || this.props.content
      ),
      actions && actions.length > 0 ? _react2.default.createElement(
        'div',
        { className: actionsTheme },
        actions.map(function (action, index) {
          return _react2.default.createElement(Action, {
            key: index,
            action: action,
            handle: _this3.handle
          });
        })
      ) : null
    );
  };

  return Popup;
}(_react.Component), _class.propTypes = {
  title: _react.PropTypes.any,
  target: _react.PropTypes.any,
  className: _react.PropTypes.string,
  style: _react.PropTypes.object,
  cancelOnBlur: _react.PropTypes.bool,
  position: _react.PropTypes.string,
  animation: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.bool]),
  showClose: _react.PropTypes.bool,
  sizeFixed: _react.PropTypes.bool,
  actions: _react.PropTypes.array,
  actionsTheme: _react.PropTypes.string,
  children: _react.PropTypes.node,
  content: _react.PropTypes.node,
  handle: _react.PropTypes.object.isRequired,
  contentPadding: _react.PropTypes.bool,
  checkInRect: _react.PropTypes.bool
}, _class.defaultProps = {
  title: null,
  actions: [],
  actionsTheme: 'default',
  showClose: false,
  target: null,
  animation: 'appear',
  position: 'top center',
  cancelOnBlur: false,
  sizeFixed: false,
  style: null,
  className: null,
  contentPadding: true,
  checkInRect: false
}, _class.displayName = 'Popup', _temp);
exports.default = Popup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/_@ali_ve-popups@4.2.3@@ali/ve-popups/build/popup.js
// module id = 285
// module chunks = 0